import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Http} from '@angular/http';
import {User} from '../../../models/user';
import {environment} from '../../../../environments/environment';
import {AuthControllerService} from '../../../services/auth-controller/auth-controller.service';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.css'],
    providers: [AuthControllerService]
})
export class LoginPage implements OnInit {

    user: User = new User();
    error: boolean;
    userName: string;
    password: string;
    emailToRestore: string;
    showRestoreForm: boolean = false;
    OAuthRedirectUrl: string = environment.OAuthRedirectUrl;
    authUrl: string = environment.authUrl;
    OAuthClientId: string = environment.OAuthClientId;
    randomHash: string = this.authService.randomId();
    showRegisteredMessage: boolean;

    constructor(private authService: AuthControllerService,
                private router: Router,
                private http: Http,
                public translate: TranslateService) {
        translate.addLangs(environment.translate.languages);
        translate.setDefaultLang(environment.translate.defaultLanguage);
        translate.use(environment.translate.defaultLanguage);
    }

    ngOnInit() {
        this.error = this.authService.getSearchParameters().error;
        if (this.authService.isAnyTokenPresent()) {
            this.authService.logout();
        }
        this.showRegisteredMessage = AuthControllerService.showRegisteredMessage
        this.randomHash = this.authService.randomId();
    }

    requestNewPassword(): void {
        this.error = false;
        if (this.emailToRestore) {
            this.authService.requestNewPassword(this.emailToRestore);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/pages/login/login.component.ts